import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "VoirDetails",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "voirDetailsRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_22 = {
  key: 0,
  class: "badge text-outline-primary"
}
const _hoisted_23 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_24 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", { class: "modal-title fs-5" }, "Détail des arrièrés de l'emplacement"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Emplacement ", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-danger" }, null, -1)),
                  _createTextVNode(" : " + _toDisplayString(_ctx.contrat.nouveauCode), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createTextVNode(" N° place ", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-danger" }, null, -1)),
                  _createTextVNode(" : " + _toDisplayString(_ctx.contrat.nouveauCode), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Ancien n° ", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-danger" }, null, -1)),
                  _createTextVNode(" : " + _toDisplayString(_ctx.contrat.ancienCode), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Numéro Compte ", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger" }, null, -1)),
                  _createTextVNode(" : " + _toDisplayString(_ctx.contrat.numCompte), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("table", _hoisted_21, [
                  _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Année"),
                      _createElementVNode("th", null, "Taux"),
                      _createElementVNode("th", null, "Mois"),
                      _createElementVNode("th", null, "Montant"),
                      _createElementVNode("th", null, "Statu")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrieres, (arr, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(arr.annee), 1),
                        _createElementVNode("td", null, _toDisplayString(arr.taux), 1),
                        _createElementVNode("td", null, _toDisplayString(arr.mois), 1),
                        _createElementVNode("td", null, _toDisplayString(arr.montant), 1),
                        _createElementVNode("td", null, [
                          (arr.montant == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Soldé"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, "En attente"))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, "Fermer", -1)),
          (_ctx.contrat.valide != 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.soumission && _ctx.soumission(...args))),
                class: "btn btn-primary"
              }, "Valider"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}